import axios from '@/axios/axios-api'
import clientCode from '@/helpers/getClientCode'

const actions = {
  addItem (context, item) {
    context.commit('setItem', item)
    context.commit('calculateAmountWhenItemIsAdded', item)
  },
  removeItem (context, item) {
    context.commit('calculateAmountWhenItemIsRemoved', item)
    context.commit('eraseItem', item)
  },
  removeItemCarta (context, item) {
    context.commit('calculateAmountWhenItemIsRemoved', item)
    context.commit('eraseItemCarta', item)
  },
  resetCarrito (context, item) {
    context.commit('resetItems', item)
  },
  editItem (context, item) {
    context.commit('editItem', item)
  },
  adjustLineQuantity (context, payload) {
    context.commit('adjustLineQuantity', payload)
  },
  async saveMercadoPagoPayment (context, params) {
    const code = clientCode()
    const response = await axios.post(`api/mp/${code}/process_payment`, params, {
      skipErrorRedirect: true
    })
    const data = response.data || {}
    if (data.status === 'approved') {
      return {
        pagoaprobado: true,
        pagoid: data.id,
        status: data.status,
        message: data.status_detail
      }
    }
    return {
      pagoaprobado: false,
      pagoid: data.id,
      status: data.status,
      message: data.status_detail || 'Pago no aprobado'
    }
  }
}

export default actions
